import { render, staticRenderFns } from "./DatePresenter.vue?vue&type=template&id=a8604664&lang=pug&"
import script from "./DatePresenter.vue?vue&type=script&lang=ts&"
export * from "./DatePresenter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports